import * as React from 'react';
export const MNSvg = React.forwardRef(function MNSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2.005 2H5v12H2.005C.894 14 0 13.1 0 11.991V4.01A2.01 2.01 0 0 1 2.005 2ZM11 2h2.995C15.106 2 16 2.9 16 4.009v7.982A2.008 2.008 0 0 1 13.995 14H11V2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M1 8h1v4H1V8Zm1.5-1a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM3 8h1v4H3V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M5 2h6v12H5z',
      }),
    ),
  );
});
MNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MN = {
  category: 'flag',
  colorable: false,
  name: 'MN',
  svg: MNSvg,
};
